// Maintien de l'écran allumé (API Screen Wake Lock). Le navigateur libère le verrou quand la page est masquée :
// il faut le redemander au retour au premier plan.

export type WakeLockState = 'active' | 'released' | 'refused' | 'unsupported'

export interface WakeLockPort {
  supported: boolean
  request: () => Promise<WakeLockState>
  release: () => Promise<void>
  onRelease: (listener: () => void) => void
}

interface SentinelLike {
  release: () => Promise<void>
  addEventListener: (type: 'release', listener: () => void) => void
}

export function createBrowserWakeLock(): WakeLockPort {
  const api = (typeof navigator !== 'undefined'
    ? (navigator as Navigator & { wakeLock?: { request: (type: 'screen') => Promise<SentinelLike> } }).wakeLock
    : undefined)
  let sentinel: SentinelLike | null = null
  const listeners = new Set<() => void>()
  return {
    supported: api !== undefined,
    async request() {
      if (!api) return 'unsupported'
      try {
        sentinel = await api.request('screen')
        sentinel.addEventListener('release', () => {
          sentinel = null
          for (const listener of listeners) listener()
        })
        return 'active'
      } catch {
        return 'refused'
      }
    },
    async release() {
      const current = sentinel
      sentinel = null
      await current?.release().catch(() => undefined)
    },
    onRelease(listener) {
      listeners.add(listener)
    },
  }
}
